
<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="fromDateChanged($event)" [initialDate]="fromDate"></common-date-picker>
    </div>
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'toDate'" (dateUpdated)="toDateChanged($event)" [initialDate]="toDate"></common-date-picker>
    </div>
    <div class="cell small-6 medium-6 large-2 vertical-align-middle">
      <button (click)="generateReport()" [disabled]="invalidDateCombination" class="button">
        Filter by Date
      </button>

    </div>
    <div class="cell small-6 medium-6 large-2 text-right vertical-align-middle">
      <button class="button" (click)="downloadReport()">Download Report</button>
    </div>

  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-8">
      &nbsp;
    </div>
    <div class="cell small-12 medium-6 large-4">
      @if (invalidDateCombination) {
        <span class="small-font-size red italic">From Date must be less than To Date</span>
      }
    </div>
  </div>
</div>
<div class="grid-container extra-wide margin-bottom">
  <div class="grid-x grid-margin-x">
    <ag-grid-angular class="data-grid " [gridOptions]="tableGridOptions" [rowData]="allReports" [excelStyles]="excelStyles" aria-label="Compliance Report"></ag-grid-angular>
  </div>
  <a #downloadLink href="" style="display: none;" target="_blank"></a>

</div>
